module.exports = __webpack_public_path__ + "static/icon__decentralized--multicolor-9090f565cefc787f04cc8dcd61bb7f58.png";